import { useCallback } from 'react';
import styled from 'styled-components';

import {
   ChevronRightIcon,
   Link,
   SidePanelContentSlot,
   SidePanelList,
   StethoscopeIcon,
   useHistoryPushWithBackAction,
} from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { historicalVisitsTranslationKeys, visitTranslationKeys } from '../../translations';
import { SidePanelLoader } from '../SidePanelLoader';
import { useHistoricalVisitsCqrsGet } from '../visitSidePanel.hooks';

import { useHistoricalVisitsListItems } from './historicalVisits.hooks';

type VisitSidePanelHistoricalVisitsProps = {
   readonly patientId: number;
   readonly currentVisitId: number;
   readonly onVisitItemClick: (visitId: number) => void;
};

const StyledLink = styled(Link)`
   align-self: flex-end;
`;
StyledLink.displayName = 'Link';

const HistoricalVisits = (props: VisitSidePanelHistoricalVisitsProps): JSX.Element => {
   const { data: historicalVisits, loading: historicalVisitsLoading } = useHistoricalVisitsCqrsGet(
      props.patientId,
      props.currentVisitId
   );

   const historicalVisitsListItems = useHistoricalVisitsListItems(historicalVisits, props.onVisitItemClick);

   const push = useHistoryPushWithBackAction(true);
   const gotToPatientVisitsHistory = useCallback(
      () =>
         push(
            visitPaths.getVisitHistoryPath({
               params: { patientId: props.patientId },
               searchParams: {},
            }),
            {
               label: visitTranslationKeys.goBackToVisit,
            }
         ),
      [push, props.patientId]
   );

   return (
      <SidePanelContentSlot headerText={historicalVisitsTranslationKeys.visitsHistory}>
         <StyledLink
            testId={'gotToPatientVisitsHistory'}
            iconSuffix={<ChevronRightIcon />}
            label={historicalVisitsTranslationKeys.goToPatientVisitHistory}
            onClick={gotToPatientVisitsHistory}
         />
         {historicalVisitsLoading ? (
            <SidePanelLoader />
         ) : (
            <SidePanelList
               icon={<StethoscopeIcon />}
               items={historicalVisitsListItems}
               noItemsMessage={historicalVisitsTranslationKeys.noVisits}
            />
         )}
      </SidePanelContentSlot>
   );
};

export { HistoricalVisits };
